/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// boostSDAppConfig.filterSettings.disabledScrollToTopAfterFilter = true;
if (boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.precisionFormatLabelSlider = 2;
}

if (boostSDAppConfig?.generalSettings) {
  boostSDAppConfig.generalSettings.disabledScrollToTopAfterFilter = true;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Log Product Item Props",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Log all props available to the ProductItem component
            const props = element.getParams().props;

            const productData = props.product;
            let rootElm = element.getRootElm();
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            );

            if (
              props.product.metafields.filter(
                (item) => item.key === "disable_compare"
              ).length > 0
            )
              {
              productItem.classList.add("hide-compare");
            }
          } catch (error) {
            console.log("Error in ProductItem customization:", error);
          }
        },
      }),
    });
  },
]);

let renderedToolbar = false;
let renderedItem = false;
let loadPrevious = false;
// Function add custom banner
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductList", {
      name: "Custom Product List",
      enabled: true,
      apply: () => ({
        beforeRender: () => {
          let productItems = document.querySelectorAll(
            ".boost-sd__product-list .boost-sd__product-item:not(.boost-sd__product-custom-banner)"
          );
          const loadPrev = document.querySelector(
            ".boost-sd__pagination-load-more-container-button"
          );
          if (loadPrev && !loadPrevious) {
            const loadPrevBtn = loadPrev?.querySelector(
              ".boost-sd__pagination-button-text"
            );
            const loadPrevBtnText = loadPrevBtn?.textContent?.toLowerCase();
            if (loadPrevBtn && loadPrevBtnText?.includes("load previous")) {
              loadPrev.classList.add("hidden");
            }
            loadPrevious = true;
          }

          if (productItems && productItems.length > 0) {
            const priceElements = document.querySelectorAll(
              ".boost-sd__format-currency > span"
            ); // Adjust this selector to match the class Boost applies to prices
            /*
            priceElements.forEach((priceElement) => {
              let priceText = priceElement.textContent.replace(
                /[^0-9.-]+/g,
                ""
              ); // Remove currency symbols
              let formattedPrice = parseFloat(priceText).toFixed(2); // Format the price to 2 decimal places
              // Re-add the currency symbol and update the displayed price
              priceElement.textContent = `$${formattedPrice}`;
            });
            */
            productItems.forEach((item) => {
              if (item.querySelector(".boost-sd__compare-button")) {
                return;
              }
              const compareButton = document.createElement("div");
              const productHandle = item
                .querySelector(".boost-sd__product-link")
                ?.href.split("/")
                .pop();
              compareButton.classList.add("boost-sd__compare-button-container");

              compareButton.innerHTML = `
                <sc-add-to-compare product-handle="${productHandle}">
                  <input type="checkbox" hidden />
                  <button class="boost-sd__compare-button">Add to Compare</button>
                </sc-add-to-compare>
              `;

              compareButton
                .querySelector("button")
                .addEventListener("click", (e) => {
                  e.preventDefault();
                  toogleCompareText(compareButton);
                });
              item.appendChild(compareButton);

              const titleElm = item.querySelector(".boost-sd__product-title");
              const titleText = titleElm.textContent.toLowerCase();
              const priceElm = item.querySelector(".boost-sd__product-price");

              const labelElm = item.querySelector(
                ".boost-sd__product-label-text"
              );
              if (titleText.includes("demo")) {
                priceElm.classList.add("hidden");
                if (labelElm) {
                  labelElm.textContent = "UNAVAILABLE";
                }
              }
              if (titleText.includes("(")) {
                let text = titleElm.textContent.replace(
                  /(\(.*?\))/g,
                  "<span>$1</span>"
                );
                titleElm.innerHTML = text;
              }

              if (titleText.includes(" ff ")) {
                titleElm.textContent = titleElm.textContent.replace(
                  " ff ",
                  " FF "
                );
                titleElm.textContent = titleElm.textContent.replace(
                  " 100l ",
                  " 100L "
                );
                titleElm.textContent = titleElm.textContent.replace(
                  " 100sl ",
                  " 100SL "
                );
                titleElm.textContent = titleElm.textContent.replace(
                  " 98l ",
                  " 98L "
                );
              }
            });
          }
        },
        afterRender(element) {
          const potentialVendorTitles = [
            ...document.querySelectorAll(".boost-sd__filter-option-title"),
          ];

          potentialVendorTitles.forEach((item) => {
            if (item.textContent.toLowerCase().includes("vendor")) {
              item.textContent = "Brand";
            }
          });

          if (document.querySelector(".boost-sd__filter-tree-wrapper")) {
            document.querySelector(
              ".boost-sd__filter-tree-wrapper"
            ).style.opacity = "1";
          }

          // Update Compare Button Text
          let productItems = document.querySelectorAll(
            ".boost-sd__product-list .boost-sd__product-item:not(.boost-sd__product-custom-banner)"
          );
          productItems.forEach((item) => {
            const compareButton = item.querySelector(
              ".boost-sd__compare-button"
            );
            toogleCompareTextOnInit(compareButton);
          });

          // Render Toolbar
          if (!renderedToolbar) {
            injectToolbarContent();
            injectPageTitles();
            renderedToolbar = true;
          }
          function injectToolbarContent() {
            if (window.screen.width < 1024) return;
            const wrapper = document.querySelector(".boost-sd__toolbar");
            wrapper.insertAdjacentHTML(
              "beforebegin",
              `
                    <div class="BoostToolbarContent">
                      <small class="BoostToolbarContent__TotalCount"><span>${0}&nbsp;</span>items</small>
                    </div>
                  `
            );
            const el = document.querySelector(
              ".BoostToolbarContent__TotalCount > span"
            );
            if (
              window?.boostSDFallback?.pagination?.items !== undefined &&
              el
            ) {
              const newVal = window?.boostSDFallback?.pagination?.items;
              const search = window.location.pathname?.includes("search");
              const isSearching = new URLSearchParams(
                window.location.search
              ).has("q");
              if (search && !isSearching) {
                el.textContent = "all";
              } else {
                el.textContent = newVal;
              }
            }
          }
          function injectPageTitles() {
            const wrapperLeft = document.querySelector(".boost-sd-left");
            const wrapperRight = document.querySelector(".boost-sd-right");
            if (
              window.screen.width >= 750 ||
              window.location.pathname?.includes("search")
            ) {
              console.log("Top bar loading...");
              wrapperLeft.insertAdjacentHTML(
                "afterbegin",
                `
                      <h3>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1278_23176)">
                        <path d="M14.7094 0.570312C13.5937 0.842187 12.6281 1.74219 12.2531 2.85781L12.1312 3.21875H6.34219C-0.107812 3.21875 0.351562 3.19531 0.1125 3.54219C0.028125 3.66875 0 3.77187 0 3.95937C0 4.25937 0.084375 4.4375 0.314062 4.61094L0.482812 4.74219L6.31875 4.76562L12.15 4.78906L12.2297 5.04688C12.5625 6.12031 13.4625 7.00625 14.5781 7.35312C14.8781 7.44687 15.0281 7.46094 15.6094 7.46094C16.2469 7.46094 16.3125 7.45156 16.7016 7.31094C17.2828 7.10469 17.5922 6.90781 18.0469 6.45312C18.4969 6.00312 18.75 5.60469 18.9047 5.10781L19.0078 4.77031L21.2672 4.75625C23.475 4.74219 23.5266 4.74219 23.6578 4.64375C24.1125 4.30625 24.1266 3.63125 23.6812 3.33125C23.5641 3.24687 23.3953 3.24219 21.2859 3.21875L19.0219 3.19531L18.9141 2.89062C18.5203 1.73281 17.5828 0.851562 16.4484 0.575C16.0687 0.48125 15.0891 0.48125 14.7094 0.570312ZM15.9469 2.05156C16.5516 2.18281 17.0719 2.59062 17.3484 3.15312C17.5453 3.55156 17.5922 4.13281 17.4609 4.53594C17.0719 5.75 15.6703 6.30312 14.5969 5.675C14.3484 5.52969 13.9594 5.11719 13.8281 4.86406C13.2562 3.74375 13.9125 2.37031 15.1641 2.06562C15.4687 1.99062 15.6422 1.98594 15.9469 2.05156Z" fill="#00335C"/>
                        <path d="M7.73242 9.05C7.03398 9.2 6.45273 9.51406 5.95117 10.0109C5.53398 10.4281 5.28555 10.8172 5.10273 11.3469L4.97148 11.7266L2.70273 11.75C0.621484 11.7734 0.429297 11.7781 0.312109 11.8578C-0.114453 12.1344 -0.114453 12.8656 0.312109 13.1422C0.429297 13.2219 0.621484 13.2266 2.70742 13.25L4.97617 13.2734L5.05586 13.5313C5.3418 14.4547 5.98867 15.2094 6.86523 15.6406C7.42305 15.9172 7.75117 15.9922 8.43555 15.9922C9.11523 15.9922 9.47617 15.8984 10.0855 15.5844C10.8777 15.1766 11.5762 14.3047 11.8059 13.4469L11.8621 13.25H17.684C23.4121 13.25 23.5105 13.25 23.6605 13.1563C23.8855 13.0156 23.998 12.8047 23.998 12.5C23.998 12.1953 23.8855 11.9844 23.6605 11.8438C23.5105 11.75 23.4121 11.75 17.684 11.75H11.8621L11.8059 11.5484C11.7355 11.2766 11.4684 10.7141 11.3137 10.4984C10.8262 9.82813 10.1465 9.34063 9.38242 9.12031C8.96992 8.99844 8.14492 8.96563 7.73242 9.05ZM8.94648 10.6203C9.33555 10.7422 9.60742 10.9109 9.85586 11.1875C10.5496 11.9563 10.5496 13.0438 9.85586 13.8125C9.60742 14.0891 9.33555 14.2578 8.94648 14.3797C8.04648 14.6609 7.07148 14.2016 6.63555 13.2969C6.49961 13.0156 6.49023 12.9547 6.49023 12.5C6.49023 12.0453 6.49961 11.9844 6.63555 11.7031C7.07148 10.7938 8.0418 10.3391 8.94648 10.6203Z" fill="#00335C"/>
                        <path d="M14.8357 17.5818C13.5841 17.8771 12.5951 18.7771 12.2294 19.9537L12.1497 20.2115L6.31381 20.235C0.482562 20.2584 0.473187 20.2584 0.341937 20.3568C-0.145563 20.7178 -0.117438 21.4631 0.388812 21.7068C0.538812 21.7771 1.0685 21.7818 6.34194 21.7818H12.131L12.2529 22.1475C12.6279 23.2678 13.5982 24.1631 14.7326 24.4303C15.131 24.524 16.0544 24.524 16.4482 24.4256C17.5919 24.149 18.6044 23.1834 18.9373 22.0631L19.0122 21.8053L21.2857 21.7818C23.3951 21.7584 23.5638 21.7537 23.681 21.6693C24.1263 21.3693 24.1123 20.6943 23.6576 20.3568C23.5263 20.2584 23.4748 20.2584 21.2669 20.2443L19.0076 20.2303L18.9044 19.8928C18.7498 19.3912 18.4966 18.9974 18.0466 18.5475C17.5826 18.0881 17.2732 17.8912 16.7013 17.6896C16.3451 17.5678 16.2091 17.5443 15.7029 17.5349C15.3138 17.5209 15.0232 17.5396 14.8357 17.5818ZM16.3685 19.2365C16.8982 19.485 17.2826 19.9209 17.4607 20.4646C17.5216 20.6475 17.5357 20.8209 17.5216 21.1256C17.5076 21.4725 17.4794 21.585 17.3435 21.8568C17.0576 22.4381 16.5279 22.8412 15.8763 22.9584C15.2951 23.0662 14.6529 22.8506 14.2029 22.3959C13.4529 21.6412 13.4294 20.4787 14.1419 19.7146C14.5872 19.2365 15.0232 19.0537 15.656 19.0771C15.9888 19.0865 16.1107 19.1146 16.3685 19.2365Z" fill="#00335C"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_1278_23176">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                        </clipPath>
                        </defs>
                        </svg>
                        <span>shop by</span>
                      </h3>
                    `
              );
              wrapperRight.insertAdjacentHTML(
                "afterbegin",
                window.location.pathname?.includes("search")
                  ? new URLSearchParams(window.location.search).has("q")
                    ? `
                      <div class="BoostSearch__Info">
                        <div>
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M28 28L20.0001 20M22.6667 13.3333C22.6667 18.488 18.488 22.6667 13.3333 22.6667C8.17868 22.6667 4 18.488 4 13.3333C4 8.17868 8.17868 4 13.3333 4C18.488 4 22.6667 8.17868 22.6667 13.3333Z" stroke="#03131E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <p>Search result for <span>${new URLSearchParams(
                            window.location.search
                          ).get("q")}</span></p>
                        </div>
              
                        <button>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="#CD201F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span>clear</span>        
                        </button>
                      </div>
                    `
                    : `
                    <div class="BoostSearch__Info">
                      <div>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28 28L20.0001 20M22.6667 13.3333C22.6667 18.488 18.488 22.6667 13.3333 22.6667C8.17868 22.6667 4 18.488 4 13.3333C4 8.17868 8.17868 4 13.3333 4C18.488 4 22.6667 8.17868 22.6667 13.3333Z" stroke="#03131E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <p>All Products</p>
                      </div>
                    </div>
                    `
                  : `
                      <h3>Products</h3>
                    `
              );
              const clearBtn = document.querySelector(
                ".BoostSearch__Info > button"
              );
              clearBtn?.addEventListener("click", () => {
                const searchParams = new URLSearchParams(
                  window.location.search
                );
                searchParams.delete("q");
                window.location.href = `${
                  window.location.pathname
                }?${searchParams.toString()}`;
              });
            } else if (window.screen.width < 748) {
              const wrapperLeft = document.querySelector(".boost-sd-right");
              wrapperLeft.insertAdjacentHTML(
                "afterbegin",
                `
                  <h3>Products</h3>
                `
              );
            }
            getCollectionSectionTitle();
            console.log("Top bar loaded...");
            const hasProduct = window.boostSDFallback?.pagination?.items;
            const isSearching = new URLSearchParams(window.location.search).has(
              "q"
            );
            const boostRightContainer = document.querySelector(
              ".boost-sd__toolbar-container"
            );
            if (!hasProduct && isSearching) {
              wrapperRight.querySelector(".BoostSearch__Info").style.display =
                "none";
              boostRightContainer.insertAdjacentHTML(
                "afterend",
                `
                  <p style="text-align:center;">Sorry, no products were found for "<span>${new URLSearchParams(
                    window.location.search
                  ).get("q")}</span>"</p>`
              );
            }
          }
          function getCollectionSectionTitle() {
            const dataEl = document.querySelector(
              "#COLLECTION_PAGE_SECTION_TITLE"
            );
            const el = document.querySelector(".boost-sd-right > h3");
            if (el && dataEl) {
              const newVal = dataEl.value;
              el.innerHTML = newVal;
              clearInterval(timer);
            }
          }
          // Render Banner
          const banner_settings = [];
          // console.log("PLP_BANNERS", document.querySelectorAll(".PLP_BANNERS"));
          document.querySelectorAll(".PLP_BANNERS")?.forEach((item, idx) => {
            const type = item.dataset.type;
            const icon = item.dataset.icon;
            const cover = item.dataset.cover;
            const data = JSON.parse(item?.value || "{}");
            banner_settings.push({
              id: idx + 1,
              html: generateCards(type, {
                background: data?.background,
                icon: icon,
                title: data?.title,
                rating: data?.rating,
                customer: data?.customer,
                review: data?.review,
                url: data?.url || data?.link,
                coverImage: cover,
                description: data?.description,
              }),
              position: data?.position,
            });
          });
          try {
            // Start customization--------------------------------------------
            let productItems = document.querySelectorAll(
              ".boost-sd__product-list .boost-sd__product-item:not(.boost-sd__product-custom-banner)"
            );
            // Remove old custom banners
            document
              .querySelectorAll(".boost-sd__product-custom-banner")
              .forEach(function (element) {
                element.remove();
              });
            // Add custom banners
            if (productItems?.length > 0) {
              for (let i = 0; i < banner_settings.length; i++) {
                if (
                  document.querySelector(
                    '[data-banner-id="' + banner_settings[i].id + '"]'
                  ) == null
                ) {
                  let bannerPosition =
                    productItems[banner_settings[i].position - 1];
                  let bannerHtml = `
                          <div class="boost-sd__product-custom-banner boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout"
                            data-banner-id="${banner_settings[i].id}"
                          >
                            ${banner_settings[i].html}
                          </div>
                        `;
                  // bannerHtml += '<div data-banner-id="'+ banner_settings[i].id +'" data-banner-spot="'+ banner_settings[i].spot +'" style="" class="boost-sd__product-custom-banner boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout">';
                  // bannerHtml += '<a style="text-decoration: none; pointer-events: none; height: 100%;" href="'+ banner_settings[i].link +'" target="'+ banner_settings[i].target +'" title="'+ banner_settings[i].title +'">';
                  // bannerHtml += banner_settings[i].html;
                  // bannerHtml += '</a>';
                  // bannerHtml += '</div>';
                  // console.log({ bannerHtml });
                  bannerPosition.insertAdjacentHTML("beforeBegin", bannerHtml);
                }
              }
            }
          } catch (e) {
            // console.error(e);
          }
        },
      }),
    });
  },
]);
function generateCards(type, data) {
  // console.log({ v: data?.rating?.value });
  switch (type) {
    case "plp_card_banner":
      return `
        <x-product-card-banner>
          <div style="background: ${data?.background}" class="t-h-full t-flex t-items-center t-justify-center t-flex-col t-gap-11">
            <img width="110" height="116" src="${data?.icon}" alt="" />
            <h3 class="t-font-gt-america t-text-[20px] t-text-center t-font-bold t-text-white m-0 uppercase t-max-w-2/3 t-mx-auto">${data?.title}</h3>
          </div>
        </x-product-card-banner>
      `;
    case "plp_review_banner_cards":
      return `
        <x-product-card-banner>
          <div style="background: ${
            data?.background
          }" class="t-h-full t-flex t-items-center t-justify-between t-flex-col t-px-6 t-py-7 t-box-border">
            <span class="t-tracking-tighter">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4607 2.7429L11.8015 5.44667C11.9844 5.82305 12.4719 6.18406 12.8833 6.25319L15.3135 6.6603C16.8676 6.92145 17.2333 8.05827 16.1134 9.17972L14.2241 11.0846C13.9042 11.4073 13.7289 12.0294 13.828 12.4749L14.3689 14.833C14.7955 16.6996 13.8127 17.4216 12.1748 16.4461L9.89699 15.0865C9.4856 14.8407 8.80758 14.8407 8.38858 15.0865L6.11074 16.4461C4.48044 17.4216 3.49007 16.6919 3.91669 14.833L4.45759 12.4749C4.55662 12.0294 4.3814 11.4073 4.06144 11.0846L2.17212 9.17972C1.05987 8.05827 1.41792 6.92145 2.97204 6.6603L5.40224 6.25319C5.80601 6.18406 6.29357 5.82305 6.47641 5.44667L7.81721 2.7429C8.54856 1.2758 9.737 1.2758 10.4607 2.7429Z" fill="${
                Math.round(data?.rating?.value || "0") >= 1
                  ? "white"
                  : "#8d8d8d"
              }"/>
              </svg>
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4607 2.7429L11.8015 5.44667C11.9844 5.82305 12.4719 6.18406 12.8833 6.25319L15.3135 6.6603C16.8676 6.92145 17.2333 8.05827 16.1134 9.17972L14.2241 11.0846C13.9042 11.4073 13.7289 12.0294 13.828 12.4749L14.3689 14.833C14.7955 16.6996 13.8127 17.4216 12.1748 16.4461L9.89699 15.0865C9.4856 14.8407 8.80758 14.8407 8.38858 15.0865L6.11074 16.4461C4.48044 17.4216 3.49007 16.6919 3.91669 14.833L4.45759 12.4749C4.55662 12.0294 4.3814 11.4073 4.06144 11.0846L2.17212 9.17972C1.05987 8.05827 1.41792 6.92145 2.97204 6.6603L5.40224 6.25319C5.80601 6.18406 6.29357 5.82305 6.47641 5.44667L7.81721 2.7429C8.54856 1.2758 9.737 1.2758 10.4607 2.7429Z" fill="${
                Math.round(data?.rating?.value || "0") >= 2
                  ? "white"
                  : "#8d8d8d"
              }"/>
              </svg>
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4607 2.7429L11.8015 5.44667C11.9844 5.82305 12.4719 6.18406 12.8833 6.25319L15.3135 6.6603C16.8676 6.92145 17.2333 8.05827 16.1134 9.17972L14.2241 11.0846C13.9042 11.4073 13.7289 12.0294 13.828 12.4749L14.3689 14.833C14.7955 16.6996 13.8127 17.4216 12.1748 16.4461L9.89699 15.0865C9.4856 14.8407 8.80758 14.8407 8.38858 15.0865L6.11074 16.4461C4.48044 17.4216 3.49007 16.6919 3.91669 14.833L4.45759 12.4749C4.55662 12.0294 4.3814 11.4073 4.06144 11.0846L2.17212 9.17972C1.05987 8.05827 1.41792 6.92145 2.97204 6.6603L5.40224 6.25319C5.80601 6.18406 6.29357 5.82305 6.47641 5.44667L7.81721 2.7429C8.54856 1.2758 9.737 1.2758 10.4607 2.7429Z" fill="${
                Math.round(data?.rating?.value || "0") >= 3
                  ? "white"
                  : "#8d8d8d"
              }"/>
              </svg>
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4607 2.7429L11.8015 5.44667C11.9844 5.82305 12.4719 6.18406 12.8833 6.25319L15.3135 6.6603C16.8676 6.92145 17.2333 8.05827 16.1134 9.17972L14.2241 11.0846C13.9042 11.4073 13.7289 12.0294 13.828 12.4749L14.3689 14.833C14.7955 16.6996 13.8127 17.4216 12.1748 16.4461L9.89699 15.0865C9.4856 14.8407 8.80758 14.8407 8.38858 15.0865L6.11074 16.4461C4.48044 17.4216 3.49007 16.6919 3.91669 14.833L4.45759 12.4749C4.55662 12.0294 4.3814 11.4073 4.06144 11.0846L2.17212 9.17972C1.05987 8.05827 1.41792 6.92145 2.97204 6.6603L5.40224 6.25319C5.80601 6.18406 6.29357 5.82305 6.47641 5.44667L7.81721 2.7429C8.54856 1.2758 9.737 1.2758 10.4607 2.7429Z" fill="${
                Math.round(data?.rating?.value || "0") >= 4
                  ? "white"
                  : "#8d8d8d"
              }"/>
              </svg>
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4607 2.7429L11.8015 5.44667C11.9844 5.82305 12.4719 6.18406 12.8833 6.25319L15.3135 6.6603C16.8676 6.92145 17.2333 8.05827 16.1134 9.17972L14.2241 11.0846C13.9042 11.4073 13.7289 12.0294 13.828 12.4749L14.3689 14.833C14.7955 16.6996 13.8127 17.4216 12.1748 16.4461L9.89699 15.0865C9.4856 14.8407 8.80758 14.8407 8.38858 15.0865L6.11074 16.4461C4.48044 17.4216 3.49007 16.6919 3.91669 14.833L4.45759 12.4749C4.55662 12.0294 4.3814 11.4073 4.06144 11.0846L2.17212 9.17972C1.05987 8.05827 1.41792 6.92145 2.97204 6.6603L5.40224 6.25319C5.80601 6.18406 6.29357 5.82305 6.47641 5.44667L7.81721 2.7429C8.54856 1.2758 9.737 1.2758 10.4607 2.7429Z" fill="${
                Math.round(data?.rating?.value || "0") >= 5
                  ? "white"
                  : "#8d8d8d"
              }"/>
              </svg>
            </span>
            <div class="t-relative t-mx-4 t-mx-auto">
              <svg class="t-absolute t-left-0 -t-top-[50px]" width="64" height="54" viewBox="0 0 64 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.4814 0.617191C16.6359 2.54878 11.7371 6.41197 8.72759 9.90723C2.89248 16.6954 0 24.201 0 32.4977C0 38.1269 0.969732 42.1372 3.22687 45.9636C5.78496 50.2499 8.35976 52.3103 12.456 53.3589C14.8804 53.9659 18.542 53.6348 20.6821 52.6046C25.1294 50.4339 28.1724 44.7127 27.8714 39.0835C27.5872 33.8774 25.1629 29.8486 20.983 27.5675C20.1637 27.126 18.9934 26.6293 18.3915 26.4637C15.9504 25.7831 12.9075 25.8383 10.968 26.5741C10.4163 26.7765 9.94812 26.9052 9.89796 26.8684C9.74748 26.6845 10.2323 24.201 10.7841 22.3982C11.9545 18.5166 13.6097 15.5364 16.2179 12.5195C18.4918 9.92562 21.0164 7.75488 23.9591 5.89687C24.7282 5.41858 24.7616 5.36339 24.5275 4.99546C24.3938 4.77471 23.6581 3.57896 22.8723 2.36482L21.4679 0.120495L20.4814 0.617191Z" fill="white" fill-opacity="0.17"/>
              <path d="M54.8901 1.37128C42.434 8.49058 35.1443 20.816 35.6626 33.914C35.8633 39.1753 37.0002 43.0569 39.4747 46.8649C42.4173 51.4271 46.2628 53.653 51.1616 53.6347C53.5525 53.6347 55.1409 53.2667 56.9967 52.2917C59.9561 50.7465 62.4306 46.9569 63.3 42.6522C63.7013 40.6286 63.5675 37.4829 62.9823 35.4961C61.5946 30.8235 57.9665 27.3282 53.4188 26.298C50.8941 25.7277 47.5168 25.9853 45.9618 26.8499C45.3599 27.1994 45.3599 27.1626 45.8114 24.9551C47.266 17.7622 50.9944 12.133 57.4816 7.38681C58.4681 6.65097 59.5381 5.93352 59.8223 5.80475C60.1233 5.67598 60.3574 5.47361 60.3574 5.38163C60.3574 5.23447 57.5652 0.690628 57.1974 0.230724C57.1472 0.157139 56.0939 0.67223 54.8901 1.37128Z" fill="white" fill-opacity="0.17"/>
              </svg>
              <blockquote class="t-border-none t-p-0 t-m-0 t-font-gt-america t-text-[18px] t-text-center t-font-normal t-text-white">
                ${data?.review}
              </blockquote>
            </div>
            <div class="t-flex t-items-center t-flex-col">
              <h3 class="t-capitalize t-m-0 t-font-gt-america t-text-[20px] t-text-center t-font-bold t-text-white">${
                data?.customer
              }</h3>
              <p class="t-mt-2 t-mb-0 t-font-gt-america t-text-[18px] t-text-center t-font-normal t-text-white">Verified Customer</p>
            </div>
          </div>
        </x-product-card-banner>
      `;
    case "plp_video_banner_cards":
      return `
        <x-product-card-banner>
          <div class="t-h-full t-flex t-items-center t-justify-between t-flex-col t-box-border">
            <iframe style="width: 100%;height: 100%;" src="https://www.youtube.com/embed/${data?.url}?si=s3zd1Rs2QCbWhdmQ&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </x-product-card-banner>
      `;
    case "plp_link_banner_cards":
      return `
        <x-product-card-banner>
          <div class="t-relative t-h-full t-flex t-items-center t-justify-between t-flex-col t-px-6 t-py-7 t-box-border t-overlay">
            <img
              class="t-absolute t-w-full t-h-full t-object-cover t-inset-0"
              src="${data?.coverImage}" 
              alt=""
              width="100%"
              height="100%"
            >
            <div class="t-flex t-items-center t-justify-between t-flex-col t-h-full t-z-50 t-w-full">
              <div class="t-flex t-flex-col t-items-center t-justify-between t-h-full t-w-full t-gap-3">
                <h3 class="t-uppercase t-m-0 t-font-gt-america t-text-[20px] t-text-center t-font-bold t-text-white">${data?.title}</h3>
                <p class="t-mt-4 t-mb-0 t-font-gt-america t-text-[18px] t-text-center t-font-normal t-text-white">${data?.description}</p>
                <div class="t-flex t-items-center t-justify-center t-w-full">
                  <a href="${data?.url}" class="t-flex t-items-center t-justify-center t-gap-3 t-text-white t-no-underline">
                    <span>view details</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 18L18 6M18 6H10M18 6V14" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </x-product-card-banner>
      `;
    default:
      return "";
  }
}
/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Modify Component",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            const productData = element.getParams().props.product;
            let rootElm = element.getRootElm();
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            );
            //**************************List of products to add swatches to **********************//
            const productTypeSwatches = ["Pickleball Paddles", "Bags", "Tennis Strings", "Shoe", "Indoor Shoe"];
            
            if (
              productTypeSwatches.includes(productData.product_type) ||
              //productData.product_type == "Pickleball Paddles" ||
              //productData.product_type == "Bags" ||
              productData.tags.includes("Apparel")
              //productData.product_type == "Shoe" ||
              //productData.product_type == "Tennis Strings"
            ) {
              if (
                productData.options_with_values[0]?.original_name != "grip_size"
              ) {
                rootElm.classList.add("show-swatches");
              }
            }
            
            if (
              productData.product_type == "Tennis Racquets" &&
              productData.options_with_values[0]?.original_name == "grip_size"
            ) {
              rootElm.classList.add("show-swatches");
              rootElm.classList.add("non-hover");
              if (productItem) {
                const label = productItem.querySelectorAll(
                  ".boost-sd__product-swatch-option label"
                );

                for (let i = 0; i < label.length; i++) {
                  const splitVar = label[i].innerHTML.split("=");
                  if (splitVar[1]) {
                    label[i].innerHTML = splitVar[1];
                  }
                }
              }
            }

            if (
              boostSDAppConfig.generalSettings.collection_id == 271612805171
            ) {
              const textHtml =
                '<div class="boost-sd__product-promo">Buy more, save more!</div>';
              if (!productItem.querySelector(".boost-sd__product-promo")) {
                productItem
                  .querySelector(".boost-sd__product-info")
                  .insertAdjacentHTML("beforeend", textHtml);
              }
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
]);
let loadMoreClicked = false;
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("PaginationLoadMore", {
      name: "Modify PaginationLoadMore",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            let rootElm = element.getRootElm();
            let loadMore = rootElm.querySelectorAll(
              ".boost-sd__pagination-load-more-container-button"
            );

            loadMore.forEach((item) => {
              const btnElm = item.querySelector(
                ".boost-sd__pagination-button-text"
              );
              const btnText = btnElm.textContent.toLowerCase();
              if (btnText.includes("load previous")) {
                item.classList.add("hidden");
              }

              if (btnText.includes("load more") && !loadMoreClicked) {
                item.addEventListener("click", () => {
                  const search = window.location.search;
                  const url = window.location.href;
                  window.history.pushState({ search }, url, search);
                  loadMoreClicked = true;
                  // console.log('load more', history)
                });
              }
            });
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("FilterOption", {
      name: "FilterOption - Customize filter option label",
      apply: () => ({
        props: (props) => {
          return props;
        },
        afterRender(element) {
          try {
            // console.log(element.getParams().props.option)
            let ids = ["pf_v_brand", "pf_t_family"];

            if (element.getParams().props.option.displayType == "list") {
              const printHTML = element.getRootElm();
              printHTML
                .querySelector(".boost-sd__filter-option-listitem")
                .classList.add("boost-column");
              //  console.log(printHTML)
            }

            let saleID = "pf_t_on_sale";

            if (
              saleID.includes(element.getParams().props.option.filterOptionId)
            ) {
              const saleHTML = element.getRootElm();
              saleHTML
                .querySelector(".boost-sd__filter-option-item-label")
                .classList.add("boost-sale");
            }
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
]);

function toogleCompareTextOnInit(button) {
  const parent = button.parentElement;
  const input = parent.querySelector("input");

  if (input.checked) {
    button.textContent = "Remove from Compare";
  } else {
    button.textContent = "Add to Compare";
  }
}

function toogleCompareText(buttonContainer) {
  const input = buttonContainer.querySelector("input");

  if (input.checked) {
    input.checked = false;
    buttonContainer.querySelector("button").textContent = "Add to Compare";
  } else {
    input.checked = true;
    buttonContainer.querySelector("button").textContent = "Remove from Compare";
  }

  // Dispatch change event
  input.dispatchEvent(new Event("change", { bubbles: true }));
}
